$.fn.awesomeCheckboxInput = function(options){
   
    var opts = $.extend({}, $.fn.awesomeCheckboxInput.defaults, options);
    this.each(function(){
      if(!$(this).parent().hasClass('noCustomCheck')){
        $(this).wrap('<div class="customCheckbox"></div>');
        $(this).before('<span class="tick-mark"></span>');
        if($(this).is(':checked')) {
          $(this).parent().addClass('customCheckboxChecked');
        }
        $(this).change(function(e){
          if($(this).is(':checked')){
            $(this).parent().addClass('customCheckboxChecked');
          } else {
            $(this).parent().removeClass('customCheckboxChecked');
          }
        });
      }
      if($(this).parent().hasClass('checkMyAccount')){
        $(this).wrap('<div class="checkboxMyAccount"></div>');
        $(this).before('<span class="tick-mark"></span>');
        if($(this).is(':checked')) {
          $(this).parent().addClass('customCheckboxChecked');
        }
        $(this).change(function(e){
          if($(this).is(':checked')){
            $(this).parent().addClass('customCheckboxChecked');
          } else {
            $(this).parent().removeClass('customCheckboxChecked');
          }
        });
      }
      // For colors filter in Collection
      if($(this).parent().is('.noCustomCheck.tw-color-label')) {
        if($(this).is(':checked')) {
          $(this).parent().addClass('active');
        } else {
          $(this).parent().removeClass('active');
        }
        $(this).change(function(e){
          if($(this).is(':checked')) {
            $(this).parent().addClass('active');
          } else {
            $(this).parent().removeClass('active');
          }
        });
      }
    });
  
};

$.fn.awesomeCheckboxInput.defaults = {
  // Defined some default props
  // background: '#a6cdec'
};

$.fn.awesomeRadioInput = function(options){
	var opts = $.extend({}, $.fn.awesomeRadioInput.defaults, options);
  this.each(function(){
    if(!$(this).parent().hasClass('noCustomRadio')){
      $(this).wrap(`<div class="customRadio"><div class="customRadioInner"></div></div>`);
      if($(this).is(':checked') || $(this).hasClass("checked")) {
        $(this).parent().addClass('customRadioChecked');
      }
      $(this).change(function(){
        let radios = $(`input[type="radio"][name="${$(this).attr('name')}"`);
        radios.each(function(item) {
          $(radios[item]).parent().removeClass('customRadioChecked');
        })
        if($(this).is(':checked')){
          $(this).parent().addClass('customRadioChecked');
        } else {
          $(this).parent().removeClass('customRadioChecked');
        }
      });
    }
	});
};

$.fn.awesomeRadioInput.defaults = {
  // Defined some default props
  // background: '#a6cdec'
};

$(function(){
  var intervalCheckbox = setInterval(() => {
    if($('.hs-form .hs-form-checkbox-display').length > 0) {
      $('.hs-form .hs-form-checkbox-display input[type=checkbox]').awesomeCheckboxInput();
      clearInterval(intervalCheckbox);
    }
  }, 300);
  $('.hs-form .hs-form-checkbox-display').awesomeCheckboxInput();
  $('input[type=checkbox]:not(.no-custom-input)').awesomeCheckboxInput();
  $('input[type=radio]:not(.no-custom-input)').awesomeRadioInput();
})
